/**
 * activityTypes.js — Source unique des TYPES d'activité d'annotation.
 *
 * Les codes (clés) sont les valeurs de l'enum backend (modèle Annotation),
 * INCHANGÉS : box_cleaning, hay_dry, hay_soaked, bedding, mucking, grooming,
 * paddock, ride, other. Les libellés affichés sont résolus par i18n via les
 * clés `session.annotations.types.<code>` — voir locales fr/en.
 *
 * Consommé par :
 *   - export/AnnotationEditor.jsx       (options du <select>)
 *   - sessions/SessionAnnotations.jsx   (libellé de la ligne d'activité)
 *   - charts/chartAnnotations.js        (libellé de la zone sur le graphique)
 *
 * Centralisation = un seul point de vérité, supprime la duplication FR.
 */

// Ordre d'affichage du sélecteur (identique à l'ancien ACTIVITY_TYPES).
export const ACTIVITY_TYPE_CODES = [
  'box_cleaning',
  'hay_dry',
  'hay_soaked',
  'bedding',
  'mucking',
  'grooming',
  'paddock',
  'ride',
  'other',
];

/** Clé i18n du libellé d'un code de type d'activité. */
export function activityTypeKey(code) {
  return `session.annotations.types.${code}`;
}

/**
 * Libellé affiché d'une annotation (bascule i18n — point qualité E1).
 *
 *   - type 'other'            → ann.label = contenu utilisateur, JAMAIS traduit.
 *   - type connu              → i18n via la clé du type (s'affiche dans la langue
 *                               active, pas le label FR gelé en base).
 *   - type absent / inconnu   → fallback sur ann.label (compat anciennes données).
 *
 * @param {{type?: string, label?: string}} ann
 * @param {(key: string) => string} t  fonction de traduction react-i18next
 * @returns {string}
 */
export function resolveAnnotationLabel(ann, t) {
  if (!ann) return '';
  if (typeof t === 'function'
      && ann.type
      && ann.type !== 'other'
      && ACTIVITY_TYPE_CODES.includes(ann.type)) {
    return t(activityTypeKey(ann.type));
  }
  return ann.label || '';
}
